import { render, staticRenderFns } from "./TestimonialsWidget.vue?vue&type=template&id=bec41382"
import script from "./TestimonialsWidget.vue?vue&type=script&lang=js"
export * from "./TestimonialsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports